module.exports = __webpack_public_path__ + "static/media/U1-T2-4-1.0200c4dd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-4-1.mp3
// module id = 584
// module chunks = 0